export const borderStyleVariants = {
  'border-style': {
    none: 'border-none',
    solid: 'border-solid',
    dashed: 'border-dashed',
    dotted: 'border-dotted',
    double: 'border-double',
    groove: 'border-groove',
    ridge: 'border-ridge',
    inset: 'border-inset',
    outset: 'border-outset',
  },
  'border-style-sm': {
    none: 'sm:border-none',
    solid: 'sm:border-solid',
    dashed: 'sm:border-dashed',
    dotted: 'sm:border-dotted',
    double: 'sm:border-double',
    groove: 'sm:border-groove',
    ridge: 'sm:border-ridge',
    inset: 'sm:border-inset',
    outset: 'sm:border-outset',
  },
  'border-style-md': {
    none: 'md:border-none',
    solid: 'md:border-solid',
    dashed: 'md:border-dashed',
    dotted: 'md:border-dotted',
    double: 'md:border-double',
    groove: 'md:border-groove',
    ridge: 'md:border-ridge',
    inset: 'md:border-inset',
    outset: 'md:border-outset',
  },
  'border-style-lg': {
    none: 'lg:border-none',
    solid: 'lg:border-solid',
    dashed: 'lg:border-dashed',
    dotted: 'lg:border-dotted',
    double: 'lg:border-double',
    groove: 'lg:border-groove',
    ridge: 'lg:border-ridge',
    inset: 'lg:border-inset',
    outset: 'lg:border-outset',
  },
  'border-style-xl': {
    none: 'xl:border-none',
    solid: 'xl:border-solid',
    dashed: 'xl:border-dashed',
    dotted: 'xl:border-dotted',
    double: 'xl:border-double',
    groove: 'xl:border-groove',
    ridge: 'xl:border-ridge',
    inset: 'xl:border-inset',
    outset: 'xl:border-outset',
  },
}
